<template>
  <div class="welcome">
    <pre-load-image></pre-load-image>
    <gene-background></gene-background>
    <div class="welcome__inner">
      <vue-audio :file="3" ref="btnClick" :redirect="redirect"></vue-audio>
      <ul class="welcome__list">
        <li class="welcome__item welcome__title">Smartcell Horseracing スマートセル　ホースレーシング</li>
        <li class="welcome__item welcome__detail">
          <p class="welcome__quote">ゲノムカードで最速のユニコーンをよびだそう！</p>
          <button class="welcome__button" id="button" @click="start"><span></span></button>
          <button class="welcome__how-to" @click="showModal"><span></span></button>
        </li>
        <li class="welcome__item welcome__image">Smartcell Horseracing スマートセル　ホースレーシング</li>
      </ul>
      <modal :id="key" :show.sync="isModal" :type="typeName"></modal>
    </div>
  </div>
</template>
<script>
  import { store } from '../store/store'
  import 'gsap'
  import Background from './Background'
  import PreLoadImage from './PreLoadImage'
  import Modal from './Modal'
  import Audio from './Audio'
  export default {
    name: 'Welcome',
    data () {
      return {
        msg: 'Welcome to Gene Game!',
        key: 'howTo',
        isModal: false,
        typeName: 'alert',
        redirect: ''
      }
    },
    components: {
      'gene-background': Background,
      'modal': Modal,
      'vue-audio': Audio,
      'pre-load-image': PreLoadImage
    },
    computed: {
    },
    methods: {
      start () {
        // store.dispatch('setCurrentScreen', 'card')
        this.redirect = 'card'
        this.$refs.btnClick.play()
      },
      showModal () {
        this.$refs.btnClick.play()
        return (this.isModal = true)
      }
    },
    mounted () {
      const timeLine = new TimelineMax()
      timeLine.append(TweenMax.to('#button', 0.8, {scale: '1.1', ease: Circ.easeNone, repeat: -1, yoyo: true}))
      store.dispatch('setResetStatus', false)
    }
  }
</script>



// WEBPACK FOOTER //
// Welcome.vue?66ee6225